import React from 'react';
import { Link } from 'react-router-dom';
import { FaArrowLeft, FaUserGraduate, FaCheckCircle, FaFileAlt, FaShieldAlt } from 'react-icons/fa';
import '../../../../assets/css/general/footer/FeaturesDetail.css';

const TrackingDonations = () => {
  return (
    <div className="feature-detail-page">
      <div className="feature-detail-container">
        {/* Back Button */}
        <Link to="/" className="back-button">
          <FaArrowLeft /> Back to Home
        </Link>

        {/* Header */}
        <div className="feature-header">
          <div className="feature-icon-large">
            <FaUserGraduate />
          </div>
          <h1 className="feature-title">Tracking Donations</h1>
          <p className="feature-subtitle">
            Monitor your contributions and see the real impact of your donations
          </p>
        </div>

        {/* Main Content */}
        <div className="feature-content">
          <section className="feature-section">
            <h2>Overview</h2>
            <p>
              Our Donation Tracking system allows donors to monitor their contributions
              with complete transparency. From payment confirmation to student impact,
              you can follow every step of your donation journey in real time.
            </p>
          </section>

          <section className="feature-section">
            <h2>How It Works</h2>
            <div className="steps-grid">
              <div className="step-card">
                <div className="step-number">1</div>
                <h3>Make a Donation</h3>
                <p>Choose a verified student request and complete your secure donation.</p>
              </div>
              <div className="step-card">
                <div className="step-number">2</div>
                <h3>Payment Confirmation</h3>
                <p>Upload or verify your payment details for transparency and record keeping.</p>
              </div>
              <div className="step-card">
                <div className="step-number">3</div>
                <h3>Track Progress</h3>
                <p>Monitor the status of your donation and see when support is delivered.</p>
              </div>
              <div className="step-card">
                <div className="step-number">4</div>
                <h3>View Impact</h3>
                <p>See how your contribution helped a student continue their education.</p>
              </div>
            </div>
          </section>

          <section className="feature-section">
            <h2>Key Features</h2>
            <div className="features-list">
              <div className="feature-item">
                <FaCheckCircle className="feature-check" />
                <div>
                  <h4>Real-time Updates</h4>
                  <p>Get live status updates on every donation you make</p>
                </div>
              </div>
              <div className="feature-item">
                <FaFileAlt className="feature-check" />
                <div>
                  <h4>Payment Records</h4>
                  <p>Access and manage all your donation receipts and payment history</p>
                </div>
              </div>
              <div className="feature-item">
                <FaShieldAlt className="feature-check" />
                <div>
                  <h4>Secure Tracking</h4>
                  <p>Your donation data is protected with advanced security measures</p>
                </div>
              </div>
              <div className="feature-item">
                <FaCheckCircle className="feature-check" />
                <div>
                  <h4>Impact Visibility</h4>
                  <p>Clearly see how your support is helping students succeed</p>
                </div>
              </div>
            </div>
          </section>

          <section className="feature-section cta-section">
            <h2>Ready to Track Your Impact?</h2>
            <p>Login to your donor account and monitor your donations in real time.</p>
            <button className="cta-button">View My Donations</button>
          </section>
        </div>
      </div>
    </div>
  );
};

export default TrackingDonations;